import { useEffect } from 'react'

const useDocumentTitle = title => {
  useEffect(() => {
    document.title = `${title} - Menu Curator`
  }, [title])
}

export default useDocumentTitle
